module.exports = __webpack_public_path__ + "e20688d9c26d3927d7932be780c6eb7e.svg";